import {
  ApiAddGiftCardToCartRequestedAction,
  apiAddGiftCardToCartFailed,
  apiAddGiftCardToCartSucceeded
} from '@spa/lib/store/api/cart/addGiftCardToCartApi';
import addGiftCardToCartAction, {
  AddGiftCardToCartActionInput,
  AddGiftCardToCartActionResult
} from '@spa/lib/actions/cart/addGiftCardToCartAction';
import { call, put } from 'typed-redux-saga';

function* addGiftCardToCartSaga({
  payload: { accountIdentifier, pin, cartId, parentActionId, actionId: requestedActionId }
}: ApiAddGiftCardToCartRequestedAction): Generator {
  try {
    const input: AddGiftCardToCartActionInput = { accountIdentifier, pin, cartId };
    const actionResult: AddGiftCardToCartActionResult = yield* call(
      addGiftCardToCartAction,
      'addGiftCardToCartAction',
      input
    );

    if (actionResult.type === 'succeeded') {
      yield* put(
        apiAddGiftCardToCartSucceeded({
          requestedActionId,
          parentActionId,
          result: actionResult.result,
          cartId
        })
      );
    } else {
      yield* put(
        apiAddGiftCardToCartFailed({
          requestedActionId,
          parentActionId,
          errorCode: actionResult.errorCode
        })
      );
    }
  } catch {
    yield* put(
      apiAddGiftCardToCartFailed({
        requestedActionId,
        parentActionId,
        errorCode: null
      })
    );
  }
}

export default addGiftCardToCartSaga;
